import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPlusSolid = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1603 12.5014L12.1435 12.5011C12.0959 12.5004 12.0475 12.5 11.9996 12.5C11.9459 12.5 11.8923 12.5005 11.8389 12.5014C11.7356 12.5032 11.6329 12.5067 11.5309 12.5119C11.3097 12.5233 11.0916 12.5426 10.8767 12.5697L10.8739 12.5701L10.8148 12.5778L10.8119 12.5782L10.8085 12.5786L10.74 12.5881C10.5809 12.6107 10.4237 12.6377 10.2685 12.6688C6.57477 13.4093 4.10097 16.4772 3.75289 20.1798L3.67578 21H12.9996V16H15.9996V13.4714L15.5669 13.2694C15.4759 13.2269 15.3838 13.1861 15.2907 13.1468C14.9374 12.998 14.5697 12.8732 14.1887 12.7741L12.1603 12.5014Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1603 12.5014C12.4875 12.5071 12.8085 12.5301 13.1225 12.5697L13.1335 12.5711C13.2211 12.5823 13.3082 12.5947 13.3947 12.6085C13.4507 12.6174 13.5065 12.6268 13.562 12.6368L13.563 12.637L13.5848 12.6409C13.6484 12.6525 13.7118 12.6648 13.7748 12.6778L12.1603 12.5014Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 17.5H19V14.5H17.5V17.5H14.5V19H17.5V22H19V19H22V17.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgUserPlusSolid;
